import React from 'react';
import { withFormProps } from '../../HOCs/withFormProps';
import { CustomRadioGroup } from './CustomRadioGroup';
import { DefaultRadioGroup } from './withFormProps';

const RadioGroupWithFormProps = withFormProps(CustomRadioGroup as any);

export const CustomRadioGroupWrapper = ({ ...props }) => {
  const { _options } = props;

  if (_options.some((el) => el.extraLabel)) {
    return (
      <RadioGroupWithFormProps
        containerProps={{
          flexDirection: 'row-reverse',
          justifyContent: 'flex-end',
          mt: 1,
        }}
        _labelProps={{ mt: 2 }}
        _errorProps={{ variant: 'error' }}
        _successProps={{ variant: 'success' }}
        {...props}
        onChange={(e) => {
          if (typeof props.onChange === 'function') {
            props.onChange(e);
            props.customRadioChange && props.customRadioChange(e);
          }
        }}
        radios={_options}
      />
    );
  }

  return <DefaultRadioGroup {..._options} {...props} />;
};
